import {
  BillSwitchEventPayload,
  ErrorEventPayload,
} from '@pinwheel/react-modal';

/**
 * This type tracks significant events that occur during a Pinwheel Link session.
 * These events can be returned through the outcome callback at the end of the
 * session to change the client behavior based on what happened during the session.
 */
export interface PinwheelLinkSessionStateInterface {
  linkTokenId: string;

  pinwheelError?: ErrorEventPayload;
  billSwitches?: BillSwitchEventPayload[];
}

export class PinwheelLinkSessionState implements PinwheelLinkSessionStateInterface {
  linkTokenId: string;

  pinwheelError?: ErrorEventPayload;
  billSwitches?: BillSwitchEventPayload[];

  constructor({ linkTokenId }: { linkTokenId: string }) {
    this.linkTokenId = linkTokenId;
    this.billSwitches = [];
  }

  public setPinwheelError(error: ErrorEventPayload) {
    this.pinwheelError = error;
  }

  public addBillSwitch(billSwitch: BillSwitchEventPayload) {
    this.billSwitches?.push(billSwitch);
  }
}
